import React, {useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import './ThresholdModal.scss'

import ButtonSpinner from "./../_common/ButtonSpinner";
import {toggleModal} from "../../store/actions/toggleModalActions";
import {updateThreshold} from "../../store/actions/alertRulesActions";

const selector = state => {
    const { language, disableButtons, alertRules } = state;
    return {
        t: language.translator,
        disableButtons: disableButtons,
        selected: alertRules.selected.alertRule,
        alertMessages: alertRules.alertMessages,
    }
};

const ThresholdModal = props => {
    const {warningType, threshold, warningEnum, responsive, closeMethod} = props;
    const { t, disableButtons, alertMessages, selected } = useSelector(selector);
    const dispatch = useDispatch();

    const [warningValue, setWarningValue] = useState('')
    const [warningMessage, setWarningMessage] = useState('')


    // const [measurementTypesOptions, setShowMeasurementTypesOptions] = useState(false);
    const [messageOptions, setShowMessageOptions] = useState(false);

    const closeModal = () => {
        if(closeMethod) {
            closeMethod()
        } else {
            dispatch(toggleModal(false, ''));
        }
    };

    useEffect(() => {
        if(threshold) {
            // console.log(threshold)
            setWarningValue(threshold.value)
            setWarningMessage(threshold.messageString ? threshold.messageString : '')
        }
    },[selected])

    const handleUpdateThresholdClick = () => {
        if(warningValue && warningMessage) {
            let body = {
                id: threshold ?  threshold?.id : null,
                idAlertRule:  selected.ruleID,
                sensorID: selected.sensorID,
                measurementType: selected.measurementType,
                warningType: warningEnum,
                value: Number(warningValue),
                messageString: warningMessage,
            }
            dispatch(updateThreshold(body))
            closeModal()
        }
    }


    return (
        <div
            onClick={e => {
                if (e.target.className === 'fieldModalBlur') {
                    closeModal()
                }
            }}
            className="fieldModalBlur">
            <div className='fieldModal'>
                <div className='fieldModalHeader'>
                    <div className='fieldModalTitleContainer'>
                        <div className='fieldModalTitle'>
                            {warningType}
                        </div>
                    </div>
                    <div className='fieldModalCloseButtonHolder'>
                        <span
                            className='material-icons fieldModalCloseButton'
                            onClick={closeModal}
                        >
                            cancel
                        </span>
                    </div>
                </div>
                <div style={responsive ? {padding: '16px'} : null} className='fieldModalContent'>
                    <form className='fieldForm' autoComplete='off'>
                        <div className='fieldFormItem'>
                            <label style={{color: '#95A4B4'}} className='fieldFormLabel'>
                                {t.gettext('Message')}
                            </label>
                            <input
                                className='fieldFormInput'
                                value={warningMessage}
                                style={{borderColor: "#95A4B4"}}
                                onInput={e => {
                                    setWarningMessage(e.target.value);
                                }}
                                type='text'
                            />
                        </div>
                        <div className='fieldFormItem'>
                            <label style={{color: '#95A4B4'}} className='fieldFormLabel'>
                                {t.gettext('Value')}
                            </label>
                            <input
                                className='fieldFormInput'
                                style={{borderColor: "#95A4B4"}}
                                defaultValue={threshold ? threshold.value : ''}
                                onInput={e => {
                                    setWarningValue(e.target.value);
                                }}
                                type='number'
                            />
                        </div>
                        <div className='fieldButtonsHolder'>
                            <button
                                style={responsive ? {color: '#fff'} : null}
                                className='fieldAddButton fieldEditButton'
                                onClick={e => {
                                    e.preventDefault();
                                    handleUpdateThresholdClick();
                                }}
                                disabled={disableButtons}
                            >
                                {t.gettext('Save')}
                                {disableButtons && <ButtonSpinner black/>}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )

}

export default ThresholdModal
